<template>
    <div class="page-view">
      <div class="vozilo-form ">
        <ejs-textbox v-model="ime_vozila" floatLabelType="Auto" placeholder="Naziv*" width="100%"></ejs-textbox>
        <ejs-textbox v-model="registracijska_oznaka" floatLabelType="Auto" placeholder="Registracija*" width="100%"></ejs-textbox>
        <ejs-dropdownlist v-model="kategorija" placeholder="Kategorija*" :dataSource='this.$store.state.prettyCategories' floatLabelType="Always"></ejs-dropdownlist>
        <ejs-dropdownlist v-model="tip_goriva" placeholder="Vrsta goriva" :dataSource='this.$store.state.fuelList' floatLabelType="Always"></ejs-dropdownlist>
        <ejs-dropdownlist v-model="tip_mjenjac" placeholder="Vrsta mjenjača" :dataSource='this.$store.state.mjenjacList' floatLabelType="Always"></ejs-dropdownlist>
        <ejs-textbox v-model="napomena" floatLabelType="Auto" placeholder="Napomena" width="100%" multiline="true"></ejs-textbox>
        <p v-if="this.saveDisabled" style="text-align: center;">Popunite obavezna polja (*)</p>
        <ejs-button class=save-btn v-on:click.native='onSpremi' :disabled="this.saveDisabled">SPREMI</ejs-button>
      </div>
    </div>
</template>

<style lang="scss">
.e-float-input {
  margin-bottom: 10px !important;
}

.e-control.e-btn {
  margin-top: 10px !important;
}

.vozilo-form {
  width: 80%;
  margin: 0 auto 0 auto;
}
</style>

<script>
export default {
  name: 'car_info',
  data() {
    return {
      isEditMode: false,
      
      ime_vozila: undefined,
      registracijska_oznaka: undefined,
      kategorija: undefined,
      tip_goriva: undefined, 
      tip_mjenjac: undefined,
      napomena: undefined
    }
  },
  mounted() {
    this.$store.state.hideCloseIcon = false;
    this.$store.state.hideSettingIcon = true;
    this.$store.state.hideFloatWidgetRight = true;
    this.$store.state.currentView = 'vozilo';
    this.$store.state.previousView = 'flota';
    if (this.$store.state.selectedCar) {
      this.isEditMode = true;
      this.$store.state.viewTitle = 'Uredi vozilo';
      this.loadEditData();
    } else {
      this.$store.state.viewTitle = 'Novo vozilo';
    }
    

  },
  methods: {
    onSpremi() {
      this.$store.state.hideLoadingIndicator = false;       //loading indicator

      let webID = 0;
      try {
        const cat = this.$store.state.categories.find(cat => cat.Name === this.kategorija);
        webID = cat.webID;
      } catch {
        webID = 0;
      }
      
      const payload = {
        ime_vozila: this.ime_vozila,
        registracijska_oznaka: this.registracijska_oznaka,
        webID: webID,
        tip_goriva: this.tip_goriva,
        tip_mjenjac: this.tip_mjenjac,
        napomena: this.napomena,
      };
      
      if (this.isEditMode === false) {
          this.$store.dispatch('insertCar', payload).then(res => {
            this.$parent.showNotification(res);
            this.$router.push(this.$store.state.previousView);
          })
          .catch(err => this.$parent.showNotification(err));
      } else {
          payload.ID = this.$store.state.selectedCar.ID;
          this.$store.dispatch('updateCar', payload).then(res => 
          {
            this.$parent.showNotification(res);
            this.$router.push(this.$store.state.previousView);
          })
          .catch(err => this.$parent.showNotification(err));
      } 
      
    },
    loadEditData() {
      this.ime_vozila = this.getCarValue('ime_vozila');
      this.registracijska_oznaka = this.getCarValue('registracijska_oznaka');
      this.kategorija = this.carCategory();
      this.tip_goriva = this.getCarValue('tip_goriva');
      this.tip_mjenjac = this.getCarValue('tip_mjenjac');
      this.napomena = this.getCarValue('napomena');
    },
    carCategory() {
      let id; 
      if (this.isEditMode) {
        id = this.$store.state.selectedCar.webID;
        if (this.$store.state.categories) {
          const cat = this.$store.state.categories.find(category => category.webID === id);
          if (cat) {
            return cat.Name;
          }
        }
      } 
      return 'undefined';
    },
    getCarValue(key) {
      if (this.$store.state.selectedCar) return this.$store.state.selectedCar[key] || undefined;
      return undefined;
    },
  },
  computed: {
    saveDisabled() {
      if(this.ime_vozila && this.registracijska_oznaka && this.kategorija) return false;
      return true;
    }
  }
}
</script>